import noPregnancyIcon from "assets/images/pregnancy/empty-pregnancy.svg";
import { Button } from "components/ui/Button";

import style from "./NoPregnancySection.module.css";

export const NoPregnancySection = ({ onAddPregnancyButtonClick }) => {
  return (
    <section className={style.emptyState}>
      <img className={style.element} alt="Element" src={noPregnancyIcon} />
      <div className={style.text}>
        <div className={style.div}>
          <div className={style.textWrapper}>No Pregnancy Recorded</div>
          <p className={style.onceThePatient}>
            There is currently no recorded pregnancy for this patient.
          </p>
        </div>
        <Button variant="primary" onClick={onAddPregnancyButtonClick}>
          Add Pregnancy
        </Button>
      </div>
    </section>
  );
};
